import React from 'react';
import { Grid } from '@mui/material';
import FormInput from '../../../inputs/FormInput';

const OrganizationTab = ({
    primaryCategoryId,
    setPrimaryCategoryId,
    categoryIds,
    setCategoryIds,
    brandId,
    setBrandId,
    tagIds,
    setTagIds,
    hierarchicalCategories,
    isLoadingCats,
    brandOptions,
    isLoadingBrands,
    tagOptions,
    isLoadingTags,
    isArabic
}) => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'التصنيف الرئيسي' : 'Main Category'}
                    type="select"
                    value={primaryCategoryId}
                    onChange={(e) => {
                        const val = e.target.value;
                        setPrimaryCategoryId(val);
                        if (val && !categoryIds.includes(parseInt(val))) {
                            setCategoryIds(prev => Array.from(new Set([...prev.map(id => parseInt(id)), parseInt(val)])));
                        }
                    }}
                    options={hierarchicalCategories}
                    disabled={isLoadingCats}
                    required
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'العلامة التجارية (Brand)' : 'Brand'}
                    type="select"
                    value={brandId}
                    onChange={(e) => setBrandId(e.target.value)}
                    options={brandOptions}
                    disabled={isLoadingBrands}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'تصنيفات أخرى' : 'Other Categories'}
                    type="multi_select"
                    selectedValue={categoryIds}
                    handleSelectChange={(e) => {
                        const val = e.target.value;
                        const numericValues = val.map(id => parseInt(id));
                        if (primaryCategoryId && !numericValues.includes(parseInt(primaryCategoryId))) {
                            setCategoryIds([...numericValues, parseInt(primaryCategoryId)]);
                        } else {
                            setCategoryIds(numericValues);
                        }
                    }}
                    options={hierarchicalCategories}
                    disabled={isLoadingCats}
                    disabledValues={[primaryCategoryId]}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'الأوسمة (Tags)' : 'Tags'}
                    type="multi_select"
                    selectedValue={tagIds}
                    handleSelectChange={(e) => setTagIds(e.target.value)}
                    options={tagOptions}
                    disabled={isLoadingTags}
                />
            </Grid>
        </Grid>
    );
};

export default OrganizationTab;
